import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import showToast from "../../services/toastifyservices";
import {
  getaxiosadminRequestWithToken,
  postaxiosadminRequestWithToken,
  postAdminFileWithToken
} from "../../api/api";
import { handleSession } from "../../api/apiSessionHandle";
import { FaEdit, FaEye, FaUserCircle } from "react-icons/fa";
import { PaginationControls } from "../../components/pagination";
import CommonSpinner from "./../../services/commonSpinner";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import endpoints from "../../api/EndPoints";
const ManageProvider = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedName, setSelectedName] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [providerData, setProviderData] = useState([]);
  const [totalProviders, setTotalProviders] = useState(0);
  const [selectedProvider, setSelectedProvider] = useState({});
  const [editModal, setEditModal] = useState(false);
  const [phoneErrors, setPhoneErrors] = useState({});
  const [errors, setErrors] = useState({});
  const [initialUpdateForm, setInitialUpdateForm] = useState({});
  const [emailError, setEmailError] = useState("");
  const [assistantEmailError, setAssistantEmailError] = useState("");
  const [causesModal, setCausesModal] = useState(false);
  const [providerCauses, setProviderCauses] = useState([]);
  const [remainingCauses, setRemainingCauses] = useState([]);
  const [selectedProviderCauses, setselectedProviderCauses] = useState([]);
  const [selectedRemainingCauses, setselectedRemainingCauses] = useState([]);
  const [addProvider, setAddProvider] = useState(false)
  const [allPractices, setAllPractices] = useState([])
  const [allAddresses, setAllAddresses] = useState([])
  const [selectedPractice, setSelectedPractice] = useState("");


  //! Pagination state
  const [currentPage, setCurrentPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState();
  const [totalPages, setTotalPages] = useState();
  const [selectedFile, setSelectedFile] = useState(null);


  const [addForm, setAddForm] = useState({
    name: "",
    description: "",
    address_id: "",
    room: "",
    modes: "",
    email: "",
    phone: "",
    assistant_email: "",
    status: "",
    password: "",
    profile: null,
    practice_id: "",
    available_for_appointments: "",
    available_for_CPEG: ""

  })

  const validateForm = ({ form, requirePassword = false }) => {
    const newErrors = {};

    if (!form.name || !form.name.trim()) newErrors.name = "Name is required";

    if (!form.email || !form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = "Email is invalid";
    }

    if (form.assistant_email?.trim()) {
      if (!/\S+@\S+\.\S+/.test(form.assistant_email)) {
        newErrors.assistant_email = "Assistant email is invalid";
      } else if (
        form.email?.trim() &&
        form.assistant_email.trim() === form.email.trim()
      ) {
        newErrors.assistant_email = "Email and Assistant email cannot be the same";
      }
    }


    if (form.phone && form.phone.trim()) {
      const numericPhone = form.phone.replace(/\D/g, "");
      if (numericPhone.length !== 10) {
        newErrors.phone = "Phone number must be 10 digits";
      }
    }
    if (requirePassword) {
      if (!form.password || !form.password.trim()) {
        newErrors.password = "Password is required";
      } else if (form.password.length < 6) {
        newErrors.password = "Password must be at least 6 characters";
      }

    }

    if (!form.practice_id) {
      newErrors.practice_id = "Practice is required";
    }

    setErrors(newErrors);

    return {
      isValid: Object.keys(newErrors).length === 0,
      errors: newErrors,
    };
  };



  const [updateForm, setUpdateForm] = useState({
    id: "",
    name: "",
    description: "",
    address_id: "",
    room: "",
    modes: "",
    email: "",
    phone: "",
    assistant_email: "",
    status: "",
    password: "",
    profile: null,
    practice_id: "",
    available_for_appointments: ""
  });


  const [formData, setFormData] = useState({
    id: "",
    name: "",
    description: "",
    address_id: "",
    room: "",
    modes: "",
    email: "",
    phone: "",
    assistant_email: "",
    status: "",
    password: "",
    profile: null,
    practice_id: "",
  });
  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "email") {
      if (value === "") {
        setEmailError(""); // Clear error if the field is empty
      } else if (!validateEmail(value)) {
        setEmailError("Invalid email format");
      } else {
        setEmailError("");
      }
    } else if (name === "assistant_email") {
      if (value === "") {
        setAssistantEmailError(""); // Clear error if the field is empty
      } else if (!validateEmail(value)) {
        setAssistantEmailError("Invalid email format");
      } else {
        setAssistantEmailError("");
      }
    }

    if (name === "phone") {
      // Remove all non-numeric characters
      value = value.replace(/\D/g, "");

      if (value === "") {
        setPhoneErrors({}); // Clear phone error if the field is empty
      } else {
        // Format as (XXX) XXX-XXXX while typing
        if (value.length > 3 && value.length <= 6) {
          value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
        } else if (value.length > 6) {
          value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(
            6,
            10
          )}`;
        }

        // Validation check for full 10-digit phone number
        if (value.length < 14) {
          setPhoneErrors({ phone: "Invalid US phone number format" }); // Set phone error
        } else {
          setPhoneErrors({}); // Clear phone error
        }
      }
    }

    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
    // Update form state
    setUpdateForm((prev) => ({ ...prev, [name]: value }));
    setFormData((prev) => ({ ...prev, [name]: value }));
    setAddForm((prev) => ({ ...prev, [name]: value }))
  };

  useEffect(() => {
    fetchAllProviders(selectedName, "active", selectedPractice);
  }, []);

  useEffect(() => {
    setUpdateForm(initialUpdateForm);
  }, [initialUpdateForm]);

  const fetchAllProviders = async (name, status, practice_id, page) => {
    //debugger
    const payload = { search_input: name, status: status, practice_id: practice_id, page: page };
    setLoading(true);
    try {
      const response = await getaxiosadminRequestWithToken(
        endpoints.FetchProvider,
        payload
      );
      if (response.success) {
        setLoading(false);
        var responsedata = response.data;
        setProviderData(response.data.data);
        setTotalProviders(responsedata.total);
        setRowsPerPage(responsedata.per_page);
        setCurrentPage(responsedata.current_page);
        setTotalPages(Math.ceil(responsedata.total / responsedata.per_page));
      }
    } catch (error) {
      handleError(error);
      setLoading(false);
    }
  };
  const handleError = (error) => {
    showToast(
      "error",
      error.response?.data?.message || "Something went wrong."
    );
    handleSession(error.response?.data, navigate);
  };

  const handleSearch = () => {
    fetchAllProviders(selectedName, selectedStatus, selectedPractice);
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      fetchAllProviders(selectedName, selectedStatus,"", page);
    }
  };
  //! handle rows per page
  const handleRowsPerPageChange = (e) => {
    const newLimit = parseInt(e.target.value, 10);
    setRowsPerPage(newLimit);
    fetchAllProviders(currentPage, newLimit);
  };

  const SyncProvidersWithTalkhr = async () => {
    try {
      setLoading(true);
      const response = await getaxiosadminRequestWithToken(
        endpoints.FetchAndUpdateTalkHrProvider
      );
      if (response.success) {
        showToast("success", response.message);
        fetchAllProviders(selectedName, selectedStatus);
      }
    } catch (error) {
      handleError(error);
      setLoading(false);
    }
  };
  const handleEdit = (data) => {
    setSelectedProvider(data);
    setEditModal(true);
    const initialData = {
      id: data.id,
      name: data.name || "",
      description: data.description || "",
      address_id: data.address_id || "",
      room: data.room || "",
      modes: data.modes || "",
      email: data.email || "",
      assistant_email: data.assistant_email || "",
      phone: data.phone || "",
      status: data.status || "",
      profile: data.profile || "",
      available_for_appointments: data.available_for_appointments || "",
      practice_id: data.practice_id || ""
    };
    setInitialUpdateForm(initialData);
    setFormData(initialData);
    setSelectedFile(null);
  };

  const EmailhandleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "email") {
      if (value == "") {
        setErrors({});
      } else {
        if (!validateEmail(value)) {
          setErrors({ ...errors, email: "Invalid email format" });
        } else {
          let newErrors = { ...errors };
          delete newErrors.email;
          setErrors(newErrors);
        }
      }
    }
  };

  const handlePhoneChange = (e) => {
    let { name, value } = e.target;

    // Remove all non-numeric characters
    value = value.replace(/\D/g, "");
    if (value == "") {
      setPhoneErrors({});
    } else {
    }
    // Format as (XXX) XXX-XXXX while typing
    if (value.length > 3 && value.length <= 6) {
      value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
    } else if (value.length > 6) {
      value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(
        6,
        10
      )}`;
    }

    // Set formatted value
    setFormData({ ...formData, [name]: value });

    // Validation check for full 10-digit phone number
    if (value.length < 14 && value != "") {
      // Because formatted length is 14 (e.g., "(212) 658-3916")
      setPhoneErrors({ ...errors, phone: "Invalid US phone number format" });
    } else {
      let newErrors = { ...errors };
      delete newErrors.phone;
      setPhoneErrors(newErrors);
    }
  };


  const handleUpdate = async () => {
    const formData = { ...updateForm };

    if (!selectedFile) {
      delete formData.profile;
    }

    const { isValid, errors: validationErrors } = validateForm({ form: formData, requirePassword: false });

    if (!isValid) {
      showToast("error", "Please fill all required fields.");
      return;
    }
    setLoading(true);
    try {
      const response = await postAdminFileWithToken(
        endpoints.UpdateProvider,
        formData
      );
      if (response.success) {
        showToast("success", response.message);
        setEditModal(false);
        setFormData("");
        await fetchAllProviders(selectedName, selectedStatus);
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    } finally {
      setLoading(false);
    }
  };

  const handleAddProvider = async () => {

    const { isValid, errors: validationErrors } = validateForm({ form: addForm, requirePassword: true });

    if (!isValid) {
      showToast("error", "Please fill all required fields.");
      return;
    }
    setLoading(true);
    try {
      const response = await postAdminFileWithToken(endpoints.CreateProvider, addForm)
      if (response) {
        showToast("success", response.message)
        setAddProvider(false)
        setAddForm("")
        await fetchAllProviders(selectedName, selectedStatus);
      }
    }
    catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    }
    finally {
      setLoading(false)
    }
  }

  const handleCause = async (data) => {
    setSelectedProvider(data);
    setLoading(true);
    try {
      const response = await getaxiosadminRequestWithToken(
        `${endpoints.FetchSingleProvider}/${data.id}`
      );
      if (response.success) {
        setLoading(false);
        setCausesModal(true);
        setProviderCauses(
          response.data.provider.causes.map((cause) => ({
            label: cause.name, // Assuming "name" is the correct display field
            value: cause.id, // Assuming "id" is the unique identifier
          }))
        );

        setRemainingCauses(
          response.data.remaining_other_causes.map((cause) => ({
            label: cause.name,
            value: cause.id,
          }))
        );
      }
    } catch (error) {
      setLoading(false);
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    }
  };

  const handleAddCause = async () => {
    const payload = {
      provider_id: selectedProvider.id,
      action: "add",
      cause_ids: selectedRemainingCauses,
    };
    try {
      const response = await postaxiosadminRequestWithToken(
              endpoints.ManageProviderCases,
        payload
      );
      if (response.success) {
        showToast("success", response.message);
        setselectedRemainingCauses([]);
        setRemainingCauses(
          response.data.other_causes.map((cause) => ({
            label: cause.name,
            value: cause.id,
          }))
        );
        setProviderCauses(
          response.data.provider.causes.map((cause) => ({
            label: cause.name, // Assuming "name" is the correct display field
            value: cause.id, // Assuming "id" is the unique identifier
          }))
        );
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
      console.log("error of ", error);
    }
  };
  const handleRemoveCause = async () => {
    const payload = {
      provider_id: selectedProvider.id,
      action: "remove",
      cause_ids: selectedProviderCauses,
    };
    try {
      const response = await postaxiosadminRequestWithToken(
         endpoints.ManageProviderCases,
        payload
      );
      if (response.success) {
        showToast("success", response.message);
        setselectedProviderCauses([]);
        setRemainingCauses(
          response.data.other_causes.map((cause) => ({
            label: cause.name,
            value: cause.id,
          }))
        );
        setProviderCauses(
          response.data.provider.causes.map((cause) => ({
            label: cause.name, // Assuming "name" is the correct display field
            value: cause.id, // Assuming "id" is the unique identifier
          }))
        );
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
      console.log("error of ", error);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the first selected file
    if (file) {
      setUpdateForm((prev) => ({
        ...prev,
        profile: file, // Store the actual file object
      }));
      setAddForm((prev) => ({
        ...prev,
        profile: file, // Store the actual file object
      }));
    }

    setSelectedFile(file);
    if (errors.profile) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors["profile"];
        return newErrors;
      });
    }
  };


  const fetchPractices = async () => {
    setLoading(true)
    try {
      const response = await postaxiosadminRequestWithToken(endpoints.practices, { limit: 100 })
      if (response) {
        setAllPractices(response?.data?.data)
      }
    }
    catch (error) {
      console.log("error of practices", error)
      handleSession(error.response?.data, navigate);
    }
    finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchPractices()
    fetchAddresses()
  }, [])

  const fetchAddresses = async () => {
  try {
    let page = 1;
    let allData = [];
    let hasMore = true;

    while (hasMore) {
      // Fetch each page dynamically
      const response = await getaxiosadminRequestWithToken(
        `${endpoints.FetchAddress}?page=${page}`
      );

      if (response && response.data.addresses) {
        const addresses = response.data.addresses;
        allData = [...allData, ...addresses.data];

        if (addresses.next_page_url) {
          page++; // Move to next page
        } else {
          hasMore = false; // No more pages
        }
      } else {
        hasMore = false;
      }
    }

    setAllAddresses(allData);
  } catch (error) {
    console.error("Error fetching addresses:", error);
  }
};

  return (
    <div className="mt-3 p-2 md:p-10 bg-gray-200">
      <div className="card">
        <span className="text-start font-bold ml-4 p-2 headingtext">
          Manage Provider
        </span>
      </div>
      <div className="card p-3">
        <div className="row d-flex align-items-end ">
          <div className="col-md-3">
            <label className="form-label font-bold">Name</label>
            <input
              type="text"
              className="form-control"
              onKeyDown={(e) =>
                e.key === "Enter" &&
                fetchAllProviders(selectedName, selectedStatus, selectedPractice)
              }
              value={selectedName}
              onChange={(e) => setSelectedName(e.target.value)}
            />
          </div>


          <div className="col-md-3">
            <label className="form-label font-bold">Status</label>
            <select
              className="form-select"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label font-bold">Practice</label>
            <select
              className="form-select"
              value={selectedPractice}
              onChange={(e) => setSelectedPractice(e.target.value)}
            >
              <option value="">Select Practice</option>
              {allPractices.map((practice) => (
                <option key={practice.id} value={practice.id}>
                  {practice.name}
                </option>
              ))}
            </select>
          </div>

          {/* Buttons section - Using d-flex to keep them aligned */}
          <div className="col-md-3 d-flex justify-content-between">
            <button
              className="btn btn-primary fw-bold btncolor"
              onClick={handleSearch}
            >
              SEARCH
            </button>
          </div>
        </div>
      </div>
      <div className="card p-3">
        <div className="flex justify-between mr-3">
          <div
            className=" d-flex align-items-center"
            style={{ fontWeight: "bold", fontSize: "16px" }}
          >
            All Providers:
            <span
              className="bg-white text-[#1e3a89]  py-1 rounded-pill ms-2"
              style={{ fontWeight: "bold" }}
            >
              {totalProviders}
            </span>
          </div>
          <div className="">
            <button
              className="flex align-items-center btn btn-primary  btncolor py-2 mr-3"
              onClick={() => { setAddProvider(true) }}
            >
              Add New Provider
            </button>
            <button
              className="flex align-items-center btn btn-secondary py-2"
              onClick={SyncProvidersWithTalkhr}
            >
              Sync Providers with Talkhr
            </button>
          </div>

        </div>
      </div>
      <div className="card">
        <div className="table-container">
          <table className="table table-striped table-hover">
            <thead className="table-header table-primary">
              <tr>
                <th>Image</th>
                <th>Provider Name</th>
                <th>Description</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {providerData.map((data) => (
                <tr key={data.id}>
                  <td>
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#f0f0f0",
                      }}
                    >
                      {data?.profile ? (
                        <img
                          src={data.profile}
                          alt={data.name}
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                          onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.style.display = "none"; // Hide broken image
                          }}
                        />
                      ) : (
                        <FaUserCircle size={100} color="#ccc" />
                      )}
                    </div>
                  </td>
                  <td className="align-middle text-capitalize">{data.name}</td>
                  <td className="align-middle text-capitalize">{data.description}</td>
                  <td className="align-middle">
                    {data.status.charAt(0).toUpperCase() + data.status.slice(1)}
                  </td>

                  <td className="align-middle">
                    <div className="d-flex gap-2">
                      <button
                        onClick={() => handleEdit(data)}
                        className="btn btn-sm btn-primary"
                      >
                        <FaEdit style={{ cursor: "pointer" }} />{" "}
                      </button>
                      <button
                        className="btn btn-sm btn-info"
                        onClick={() => handleCause(data)}
                      >
                        <FaEye style={{ cursor: "pointer" }} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Modal
        show={editModal}
        onHide={() => {
          setEditModal(false);
          setFormData(initialUpdateForm);
          setEmailError("");
          setAssistantEmailError("");
          setPhoneErrors({});
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Provider</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <Form>
            {[
              ["name", "email"],
              ["phone", "assistant_email"],
              ["practice_id", "address_id"],
              ["description", "modes"],
              ["available_for_appointments", "available_for_CPEG"],
              ["room", "status"],
             ...(selectedProvider?.has_password === false ? [["password", "profile"]] : [["profile"]])
            ].map((pair, index) => (
              <div className="row mb-3" key={index}>
                {pair.map((key) => (
                  <div className={key === "description" ? "col-6 " : "col-md-6"} key={key}>
                    <Form.Group>
                      {key !== "profile" && (
                        <Form.Label className="fw-bold">
                          {
                            key === "available_for_CPEG"
                              ? "AVAILABLE FOR CPEG"
                              : key === "practice_id"
                                ? "PRACTICE"
                                : key === "available_for_appointments"
                                  ? "AVAILABLE FOR APPOINTMENTS"
                                  : key === "address_id"
                                    ? "LOCATION"
                                    : key.replaceAll("_", " ").toUpperCase()
                          }
                          {(key === "name" || key === "email" || key === "practice_id") && (
                            <span className="text-danger">*</span>
                          )}
                        </Form.Label>

                      )}

        {key === "password" ? (
              <>
                <Form.Control
                  type="password"
                  name={key}
                  value={updateForm[key]}
                  onChange={handleChange}
                />
                {errors[key] && (
                  <div className="text-danger">{errors[key]}</div>
                )}
              </>
            ) 
                      :key === "status" ? (
                        <>
                          <Form.Select
                            name={key}
                            value={updateForm[key]}
                            onChange={handleChange}
                          >
                            {/* <option value="">Select Status</option> */}
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </Form.Select>
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      ) : key === "modes" ? (
                        <>
                          <Form.Select
                            name={key}
                            value={updateForm[key]}
                            onChange={handleChange}
                          >
                            <option value="">Select mode</option>
                            <option value="office">Office</option>
                            <option value="telehealth">Telehealth</option>
                          </Form.Select>
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      ) : key === "available_for_appointments" || key === "available_for_CPEG" ? (
                        <Form.Select
                          name={key}
                          value={updateForm[key]}
                          onChange={handleChange}

                        >
                          <option value="">Select Option</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Form.Select>) : key === "email" || key === "assistant_email" ? (
                          <>
                            <Form.Control
                              type="email"
                              name={key}
                              value={updateForm[key]}
                              onChange={handleChange}
                            />
                            {key === "email" && emailError && (
                              <div className="text-danger">{emailError}</div>
                            )}
                            {key === "assistant_email" && assistantEmailError && (
                              <div className="text-danger">{assistantEmailError}</div>
                            )}
                            {errors[key] && (
                              <div className="text-danger">{errors[key]}</div>
                            )}
                          </>
                        ) : key === "phone" ? (
                          <>
                            <Form.Control
                              type="text"
                              name={key}
                              value={updateForm[key] || ""}
                              onChange={handleChange}
                              className={phoneErrors.phone ? "is-invalid" : ""}
                            />
                            {phoneErrors.phone && (
                              <div className="text-danger">{phoneErrors.phone}</div>
                            )}
                            {errors[key] && (
                              <div className="text-danger">{errors[key]}</div>
                            )}
                          </>
                        ) : key === "room" ? (
                          <>
                            <Form.Control
                              type="number"
                              name={key}
                              value={updateForm[key]}
                              onChange={handleChange}

                              min="0"
                              style={{
                                MozAppearance: "textfield",
                                WebkitAppearance: "none",
                                appearance: "none",
                              }}
                              onKeyDown={(e) => {
                                if (["e", "+", "-"].includes(e.key)) e.preventDefault();
                              }}

                            />
                            {errors[key] && (
                              <div className="text-danger">{errors[key]}</div>
                            )}
                          </>
                        ) : key === "practice_id" ? (
                          <>
                            <Form.Select
                              name={key}
                              value={updateForm[key]}
                              onChange={handleChange}

                            >
                              <option value="">Select Practice</option>
                              {allPractices.map((practice) => (
                                <option key={practice.id} value={practice.id}>
                                  {practice.name}
                                </option>
                              ))}
                            </Form.Select>
                            {errors[key] && (
                              <div className="text-danger">{errors[key]}</div>
                            )}
                          </>
                        ) : key === "address_id" ? (
                          <>
                            <Form.Select
                              name={key}
                              value={updateForm[key]}
                              onChange={handleChange}

                            >
                              <option value="">Select Location</option>
                              {allAddresses.map((address) => (
                                <option key={address.id} value={address.id}>
                                  {address.city}
                                </option>
                              ))}
                            </Form.Select>
                            {errors[key] && (
                              <div className="text-danger">{errors[key]}</div>
                            )}
                          </>
                        ) : key === "profile" ? (
                          <Form.Group controlId="profile">
                            <Form.Label className="fw-bold me-2 mb-0">Profile Picture:</Form.Label>
                            <Form.Control
                              type="file"
                              onChange={handleFileChange}
                              accept="image/png, image/jpeg, image/jpg"
                              className="mt-2"
                            />
                            {errors.profile && (
                              <Form.Control.Feedback type="invalid" className="d-block">
                                {errors.profile}
                              </Form.Control.Feedback>
                            )}
                            <div className="d-flex align-items-center mt-2">
                              {(updateForm.profile instanceof File || typeof updateForm.profile === "string") && (
                                <img
                                  src={
                                    updateForm.profile instanceof File
                                      ? URL.createObjectURL(updateForm.profile)
                                      : updateForm.profile
                                  }
                                  alt="Preview"
                                  className="ms-2"
                                  style={{
                                    width: "90px",
                                    height: "90px",
                                    borderRadius: "50%",
                                    backgroundColor: "#f0f0f0",
                                  }}
                                />
                              )}
                            </div>
                          </Form.Group>
                        ) : (
                        <>
                          <Form.Control
                            type="text"
                            name={key}
                            value={updateForm[key]}
                            onChange={handleChange}
                          />
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      )}
                    </Form.Group>
                  </div>
                ))}
              </div>
            ))}

            {/* Profile Upload */}

          </Form>

        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setEditModal(false);
              setFormData(initialUpdateForm);
              setEmailError("");
              setAssistantEmailError("");
              setPhoneErrors({});
            }}
          >
            Close
          </Button>
          <Button variant="primary" onClick={handleUpdate} disabled={loading}>
            {loading ? (
              <>
                <Spinner animation="border" size="sm" /> Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={causesModal}
        onHide={() => {
          setCausesModal(false);
          setselectedRemainingCauses([]);
          setselectedProviderCauses([]);
        }}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Provider Causes Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custom-modal-body">
          <div className="card flex flex-row items-start justify-start py-1 px-5 mb-2 gap-3 bg-light sm:flex-col sm:items-start sm:text-left ">
            {/* Profile Image */}
            <div
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f0f0f0",
              }}
            >
              {selectedProvider?.profile ? (
                <img
                  src={selectedProvider.profile}
                  alt={selectedProvider.name}
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = "none";
                  }}
                />
              ) : (
                <FaUserCircle size={100} color="#ccc" />
              )}
            </div>

            {/* Provider Details */}
            <div className="flex items-start flex-col ml-3 sm:ml-0">
              <div className="font-bold text-lg text-center align-middle">
                {selectedProvider.name}
              </div>
              <div className="text-lg">
                {selectedProvider.description || "No description"}
              </div>

              {/* Address Section */}

              <div className="flex items-center w-[500px] break-words sm:w-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 mr-1 flex-shrink-0"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  color="red"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 2C8.13 2 5 5.13 5 9c0 4.75 6.35 11.72 6.62 12.01.22.24.54.24.76 0C12.65 20.72 19 13.75 19 9c0-3.87-3.13-7-7-7zm0 10.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="truncate w-full lg:w-auto md:w-[100px] sm:w-[100px]">
                  {selectedProvider?.address || "No address found"}
                </span>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="p-3">
              <div className="row mb-3">
                {/* Add Cause Section */}
                <div className="col-md-6 col-sm-12 d-flex flex-column">
                  <h6 className="fw-bold text-nowrap">
                    Add a cause (multiple)
                  </h6>
                  <MultiSelect
                    options={remainingCauses}
                    value={selectedRemainingCauses.map((id) =>
                      remainingCauses.find((cause) => cause.value === id)
                    )}
                    onChange={(selected) =>
                      setselectedRemainingCauses(selected.map((s) => s.value))
                    }
                    labelledBy="Select Claim Status"
                    valueRenderer={(selected) =>
                      selected.length === remainingCauses.length
                        ? remainingCauses.map((s) => s.label).join(", ")
                        : selected.map((s) => s.label).join(", ")
                    }
                  />
                  <button
                    className="btn btn-info mt-2 w-100 text-nowrap"
                    style={{ minHeight: "40px" }}
                    onClick={handleAddCause}
                  >
                    Add Cause/Speciality
                  </button>
                </div>

                {/* Remove Cause Section */}
                <div className="col-md-6 col-sm-12 d-flex flex-column">
                  <h6 className="fw-bold text-nowrap">
                    Remove a cause (multiple)
                  </h6>
                  <MultiSelect
                    options={providerCauses}
                    value={selectedProviderCauses.map((id) =>
                      providerCauses.find((cause) => cause.value === id)
                    )}
                    onChange={(selected) =>
                      setselectedProviderCauses(selected.map((s) => s.value))
                    }
                    labelledBy="Select Appointment Status"
                    valueRenderer={(selected) =>
                      selected.length === providerCauses.length
                        ? providerCauses.map((s) => s.label).join(", ")
                        : selected.map((s) => s.label).join(", ")
                    }
                  />
                  <button
                    className="btn btn-warning mt-2 w-100 text-nowrap"
                    style={{ minHeight: "40px" }}
                    onClick={handleRemoveCause}
                  >
                    Remove Cause/Speciality
                  </button>
                </div>
              </div>
            </div>

            <div className=" mt-2">
              {/* Green Header */}
              <div className=" text-white bg-[#28a745]  fw-semibold text-lg p-2 flex  items-center justify-center">
                Provider's Speciality and Causes
              </div>
              <div className="flex flex-wrap mr-1 mt-2">
                {/* {remainingCauses.map((cause) => (
                  <ul key={cause.value}>
                    <li> ✅{cause.label}</li>
                  </ul>
                ))} */}
                {providerCauses.map((cause) => (
                  <ul key={cause.value}>
                    <li>✅ {cause.label}</li>
                  </ul>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setCausesModal(false);
              setselectedRemainingCauses([]);
              setselectedProviderCauses([]);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={addProvider}
        onHide={() => {
          setAddProvider(false);
          setAddForm({
            name: "",
            description: "",
            address_id: "",
            room: "",
            modes: "",
            email: "",
            phone: "",
            assistant_email: "",
            status: "",
            password: "",
            profile: null,
            practice_id: ""
          });
          setEmailError("");
          setAssistantEmailError("");
          setPhoneErrors({});
          setErrors({})
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Provider</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <Form>
            {[
              ["name", "email"],
              ["phone", "assistant_email"],
              ["practice_id", "address_id"],
              ["description", "modes"],
              ["available_for_appointments", "available_for_CPEG"],
              ["room", "status"],
              ["password", "profile"],
            ].map((pair, index) => (
              <div className="row mb-3" key={index}>
                {pair.map((key) => (
                  <div className="col-md-6" key={key}>
                    <Form.Group>
                      {key !== "profile" && (
                        <Form.Label className="fw-bold">
                          {key === "available_for_CPEG"
                            ? "AVAILABLE FOR CPEG"
                            : key === "available_for_appointments"
                              ? "AVAILABLE FOR APPOINTMENTS"
                              : key === "practice_id"
                                ? "PRACTICE"
                                : key === "address_id"
                                  ? "LOCATION"
                                  : key.replace("_", " ").toUpperCase()}

                          {(key === "name" || key === "email" || key === "password" || key === "practice_id") && (
                            <span className="text-danger">*</span>
                          )}
                        </Form.Label>

                      )}

                      {key === "status" ? (
                        <>
                          <Form.Select
                            name={key}
                            value={addForm[key]}
                            onChange={handleChange}
                          >
                            {/* <option value="">Select Status</option> */}
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </Form.Select>
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      ) : key === "modes" ? (
                        <>
                          <Form.Select
                            name={key}
                            value={addForm[key]}
                            onChange={handleChange}
                          >
                            <option value="">Select mode</option>
                            <option value="office">Office</option>
                            <option value="telehealth">Telehealth</option>
                          </Form.Select>
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      ) : key === "email" || key === "assistant_email" ? (
                        <>
                          <Form.Control
                            type="email"
                            name={key}
                            value={addForm[key]}
                            onChange={handleChange}
                          />
                          {key === "email" && emailError && (
                            <div className="text-danger">{emailError}</div>
                          )}
                          {key === "assistant_email" && assistantEmailError && (
                            <div className="text-danger">{assistantEmailError}</div>
                          )}
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      ) : key === "phone" ? (
                        <>
                          <Form.Control
                            type="text"
                            name={key}
                            value={addForm[key] || ""}
                            onChange={handleChange}
                            className={phoneErrors.phone ? "is-invalid" : ""}
                          />
                          {phoneErrors.phone && (
                            <div className="text-danger">{phoneErrors.phone}</div>
                          )}
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      ) : key === "room" ? (
                        <>
                          <Form.Control
                            type="number"
                            name={key}
                            value={addForm[key]}
                            onChange={handleChange}

                            min="0"
                            style={{
                              MozAppearance: "textfield",
                              WebkitAppearance: "none",
                              appearance: "none",
                            }}
                            onKeyDown={(e) => {
                              if (["e", "+", "-"].includes(e.key)) e.preventDefault();
                            }}

                          />
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      ) : key === "practice_id" ? (
                        <>
                          <Form.Select
                            name={key}
                            value={addForm[key]}
                            onChange={handleChange}

                          >
                            <option value="">Select Practice</option>
                            {allPractices.map((practice) => (
                              <option key={practice.id} value={practice.id}>
                                {practice.name}
                              </option>
                            ))}
                          </Form.Select>
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      ) : key === "address_id" ? (
                        <>
                          <Form.Select
                            name={key}
                            value={addForm[key]}
                            onChange={handleChange}

                          >
                            <option value="">Select Location</option>
                            {allAddresses.map((address) => (
                              <option key={address.id} value={address.id}>
                                {address.city}
                              </option>
                            ))}
                          </Form.Select>
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      ) : key === "profile" ? (
                        <Form.Group controlId="profile">
                          <Form.Label className="fw-bold me-2 mb-0">Profile Picture:</Form.Label>

                          <Form.Control
                            type="file"
                            onChange={handleFileChange}
                            accept="image/png, image/jpeg, image/jpg"
                            className="mt-2"
                          />
                          {errors.profile && (
                            <Form.Control.Feedback type="invalid" className="d-block">
                              {errors.profile}
                            </Form.Control.Feedback>
                          )}
                          <div className="d-flex align-items-center mt-2">

                            {addForm.profile instanceof File && (
                              <img
                                src={URL.createObjectURL(addForm.profile)}
                                alt="Preview"
                                className="ms-2"
                                style={{
                                  width: "90px",
                                  height: "90px",
                                  borderRadius: "50%",
                                  backgroundColor: "#f0f0f0",
                                }}
                              />
                            )}
                          </div>
                        </Form.Group>
                      ) : key === "available_for_appointments" || key === "available_for_CPEG" ? (
                        <>
                          <Form.Select
                            name={key}
                            value={addForm[key]}
                            onChange={handleChange}
                          >
                            <option value="">Select an option</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </Form.Select>
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      ) : (
                        <>
                          <Form.Control
                            type="text"
                            name={key}
                            value={addForm[key]}
                            onChange={handleChange}
                          />
                          {errors[key] && (
                            <div className="text-danger">{errors[key]}</div>
                          )}
                        </>
                      )}
                    </Form.Group>
                  </div>
                ))}
              </div>
            ))}

            {/* Profile Upload */}

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setAddProvider(false);
              setAddForm({
                name: "",
                description: "",
                address_id: "",
                room: "",
                modes: "",
                email: "",
                phone: "",
                assistant_email: "",
                status: "",
                password: "",
                profile: null,
                practice_id: ""
              });
              setEmailError("");
              setAssistantEmailError("");
              setPhoneErrors({});
              setErrors({})
            }}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleAddProvider}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" /> Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {loading ? null : (
        <div className="pagination-controls">
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onLimitPerPage={handleRowsPerPageChange}
          />
        </div>
      )}
      {loading && <CommonSpinner />}
    </div>
  );
};

export default ManageProvider;
